<template>
    <div class="parcel-marker" @click="openParcelMap()">
        <div class="mask mask-squircle bg-base-100 h-14 w-14 p-1 marker-p">
        <img :src="parcel.image_url" alt="" class="mask mask-squircle w-full h-full object-cover" loading="lazy"/>
        </div>
        <div class="text-xs font-bold badge absolute text-primary w-max mt-1 max-content">{{ parcel.title }}</div>
    </div>

</template>

<script>
import mapboxgl from 'mapbox-gl';

export default {
    props: {
        mySmartMap: {
            type: Object,
            default: function () {
                return null;
            }
        },
        parcel: {
            type: Object,
            required: true
        }
    },
    methods: {
        openParcelMap() {
            this.triggerEventGA('click_parcel', {
                id: this.parcel.id,
                title: this.parcel.title
            });
            window.location.replace(this.parcel.display_link);
        }
    },
    mounted() {
        new mapboxgl.Marker(this.$el).setLngLat(this.parcel.coordinates).addTo(this.mySmartMap);
    }
};
</script>

<style>
.max-content{
    width: max-content;
}
.marker-p{
    padding: 2px;
    
}
.marker-p:hover {
    transform: scale(1.1);
    transition-timing-function: ease-out;
    transition-duration: 60ms;
}
</style>